import React from 'react';
import Icon from "../";
export default function IconMore(props) {
  return React.createElement(Icon, Object.assign({}, props, {
    dangerouslySetInnerHTML: {
      __html: "<path d=\"M12 11.25a.75.75 0 10.75.76.74.74 0 00-.75-.76zM5.25 11.25A.75.75 0 106 12a.74.74 0 00-.75-.75zM18.75 11.25a.75.75 0 10.75.76.74.74 0 00-.75-.76z\" fill=\"#181818\" stroke=\"#181818\"/>"
    }
  }));
}